<sl-label size="large" i18n>We are now importing your data. Please wait...</sl-label>
<sl-progress-bar [percentage]="progress"></sl-progress-bar>
<sl-label size="small">{{progressText}}</sl-label>
